import axios from "axios";
/* eslint-disable */

export default () => {
  // const data = { baseURL:"http://localhost:4252/"}
  const data = { baseURL:"https://agriedge.ca/aquaedgeweb/"}
  // const data = { baseURL:"https://agriedge.ca/asari_platfomr/"} https://agriedge.ca/aquaedgeweb/
  return axios.create(data);
 
};
